import { useMemo } from 'react';
import { useEntity } from '@backstage/plugin-catalog-react';
import {
  type Output,
  union,
  undefined_,
  object,
  string,
  optional,
  record,
  literal,
  parse,
} from 'valibot';

const configSchema = union(
  [
    undefined_(),
    object({
      template: string("Missing property 'templateName'"),
      createMode: union(
        [literal('manual'), literal('auto')],
        "createMode must be 'auto' or 'manual'",
      ),
      params: optional(
        record(
          string(),
          string(),
          'If params is defined, it must be JSON-serializable as Record<string, string>',
        ),
      ),
    }),
  ],
  'Coder schema is invalid',
);

export type CoderConfig = Output<typeof configSchema>;

export function useCoderConfig() {
  const { entity } = useEntity();
  const rawConfig = entity.spec?.coder;
  return useMemo(() => parse(configSchema, rawConfig), [rawConfig]);
}
